import { isSupportedAsMainImage } from 'shared/domain/document/isSupportedAsMainImage';
import { isImageConvertStatusSuccess } from 'shared/domain/imageConvertStatus/imageConvertStatus';
import { DocumentOnView } from 'presentation/document/documentOnView';
import { isUploadStatusSuccess } from 'shared/types/uploadStatus';
import {
  emptyPdfDocumentCounts,
  PdfDocumentCounts,
} from '../classifyDocumentsForPdfEstimate';

function isDeleted(document: DocumentOnView): boolean {
  return document.deleted;
}

function isUploadSuccessful(document: DocumentOnView): boolean {
  return isUploadStatusSuccess(document.data.uploadStatus);
}

export function isPdfSupportedImage(document: DocumentOnView): boolean {
  if (isDeleted(document) || !isUploadSuccessful(document)) {
    return false;
  }
  return (
    isSupportedAsMainImage(document.data.extension) ||
    isImageConvertStatusSuccess(document.imageConvertStatus)
  );
}

export function isPdfSupportedDocument(document: DocumentOnView): boolean {
  return !isDeleted(document) && isUploadSuccessful(document);
}

export function classifyDocumentOnViewsForPdfEstimate(
  documents: DocumentOnView[]
): PdfDocumentCounts {
  const counts = emptyPdfDocumentCounts();

  for (const document of documents) {
    if (!isPdfSupportedDocument(document)) {
      continue;
    }

    counts.all += 1;
    counts.descriptionChars += (document.description ?? '').length;

    if (isPdfSupportedImage(document)) {
      counts.images += 1;
    } else {
      counts.nonImages += 1;
    }
  }

  return counts;
}

export function classifyDocumentOnViewMapForPdfEstimate(
  documentsByKey: Record<string, DocumentOnView[]>
): PdfDocumentCounts {
  const totals = emptyPdfDocumentCounts();

  for (const documents of Object.values(documentsByKey)) {
    const partial = classifyDocumentOnViewsForPdfEstimate(documents);
    totals.images += partial.images;
    totals.nonImages += partial.nonImages;
    totals.all += partial.all;
    totals.descriptionChars += partial.descriptionChars;
  }

  return totals;
}
